export default __webpack_public_path__ + "static/media/white_close_x.1b2ac462.svg";